<template>
  <or-layout>
    <div>
      <a-table :dataSource="datalist" :rowKey="item => item.id" :pagination="false" :loading="loading">
        <a-table-column key="exam_title" data-index="exam_title" title="考试名字" />
        <a-table-column key="exam_day" title="考试日期" data-index="exam_day" />
        <a-table-column key="state" title="状态">
          <template slot-scope="item">
            <span v-if="item.state == 0">进行中</span>
            <span v-if="item.state == 1">已结束</span>
          </template>
        </a-table-column>
        <a-table-column key="opt" title="操作">
          <template slot-scope="item">
            <a-button type="primary" @click="showExamInfo(item.id)">成绩分析</a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :footer="null" :visible="visible" title="考试分析" @ok="visible = false" :destroyOnClose="true"
      @cancel="visible = false" :width="1300">
      <a-tabs class="row" type="card" :loading="loading" @change="switchTabs">
        <a-tab-pane tab="学生成绩" key="stuent">
          <a-form layout="inline">
            <a-form-item>
              <a-select v-model="org_id" placeholder="机构" style="width: 100px;" :loading="loading" :disabled="true">
                <a-select-option v-for="(item) in orgList" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select v-model="campus_id" placeholder="校区" style="width: 140px;" width="200px;" :loading="loading" @change="get_exam_squad_list"
                :allowClear="true">
                <a-select-option v-for="(item) in campusList" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select v-model="grade_id" placeholder="年级" style="width: 100px;" :loading="loading" :allowClear="true" @change="get_exam_squad_list">
                <a-select-option v-for="(item) in myGradeList" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select v-model="class_type" placeholder="班型" style="width: 100px;" :loading="loading" :allowClear="true" @change="get_exam_squad_list">
                <a-select-option v-for="(item) in squadType" :key="item.name" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="classList.length>0">
              <a-select v-model="class_seq" placeholder="班级" style="width: 200px;" :loading="loading" :allowClear="true">
                <a-select-option v-for="(item) in classList" :key="item.squad_id" :value="item.squad_id">{{ item.squad_name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-input :allowClear="true" v-model="student_name" placeholder="姓名搜索"></a-input>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" :loading="loading" icon="search" @click="getTableList">搜索</a-button>
              <a-button :disabled="student_name != ''" class="active_btn" :loading="loading" type="primary"
                icon="file-excel" @click="is_export = true; getTableList()">导出</a-button>
              <span class="active_btn">记录总数:{{ studentList.length }}</span>
            </a-form-item>
          </a-form>
          <a-table :dataSource="studentList" :rowKey="item => item.id" :pagination="false" :loading="loading" bordered>
            <a-table-column key="campus_name" title="校区" data-index="campus_name" />
            <a-table-column key="grade_id" title="年级">
              <template slot-scope="item">
                {{ item.squadinfo.grade_name }}
              </template>
            </a-table-column>
            <a-table-column key="class_type" title="类型">
              <template slot-scope="item">
                {{ classType(item.class_type) }}班
              </template>
            </a-table-column>
            <a-table-column key="class_seq" title="班级">
              <template slot-scope="item">
                {{ item.squad_name }}
              </template>
            </a-table-column>
            <a-table-column key="student_name" title="名字" data-index="student_name" />
            <a-table-column key="excel_seq" title="序号" data-index="excel_seq"
              :sorter="(item1, item2) => item1.excel_seq - item2.excel_seq" />
            <a-table-column key="student_score" title="总分" data-index="student_score"
              :sorter="(item1, item2) => item1.student_score - item2.student_score" />
            <!--<a-table-column key="opt" title="操作">-->
            <!--<template slot-scope="item">-->
            <!--<student-home-work :user_id="item.id" :squad_id="squad_id"/>-->
            <!--&lt;!&ndash;<a-button type="primary" htmlType="submit" icon="ordered-list" @click="showHomeWorkInfo(item.id)" >查看作业</a-button>&ndash;&gt;-->
            <!--</template>-->
            <!--</a-table-column>-->
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="班级分析" key="squad">
          <a-form layout="inline">
            <a-form-item>
              <a-select v-model="org_id" placeholder="机构" style="width: 100px;" :loading="loading" :disabled="true">
                <a-select-option v-for="(item) in orgList" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select v-model="campus_id" placeholder="校区" style="width: 140px;" width="200px;" :loading="loading"
                :allowClear="true">
                <a-select-option v-for="(item) in campusList" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select v-model="grade_id" placeholder="年级" style="width: 100px;" :loading="loading" :allowClear="true">
                <a-select-option v-for="(item) in myGradeList" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select v-model="class_type" placeholder="班型" style="width: 100px;" :loading="loading" :allowClear="true">
                <a-select-option v-for="(item) in squadType" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item>
              <a-button type="primary" :loading="loading" htmlType="submit" icon="search"
                @click="getClassInfoList">搜索</a-button>
              <a-button class="active_btn" :loading="loading" type="primary" icon="file-excel"
                @click="is_export = true; getClassInfoList()">导出</a-button>
              <span class="active_btn">记录总数:{{ classDataList.length }}</span>
            </a-form-item>
          </a-form>
          <a-table :dataSource="classDataList" :rowKey="item => item.id" :pagination="false" :loading="loading" bordered>
            <a-table-column key="campus_name" title="班级">
              <template slot-scope="item">
                {{ item.campus_name }} - {{ item.grade_name }} - {{ item.class_type }} - {{ item.squad_name }}
              </template>
            </a-table-column>
            <a-table-column key="teacher_name" title="教师" data-index="teacher_name" />
            <a-table-column key="class_arrive" title="应到" data-index="class_arrive"
              :sorter="(item1, item2) => item1.class_arrive - item2.class_arrive" />
            <a-table-column key="class_actual" title="实到" data-index="class_actual"
              :sorter="(item1, item2) => item1.class_actual - item2.class_actual" />
            <a-table-column key="superior_cnt" title="优生数" data-index="superior_cnt"
              :sorter="(item1, item2) => item1.superior_cnt - item2.superior_cnt" />
            <a-table-column key="superior_rate" title="优生率" data-index="superior_rate"
              :sorter="(item1, item2) => item1.superior_rate - item2.superior_rate" />
            <a-table-column key="ordinary_cnt" title="合格数" data-index="ordinary_cnt"
              :sorter="(item1, item2) => item1.ordinary_cnt - item2.ordinary_cnt" />
            <a-table-column key="ordinary_rate" title="合格率" data-index="ordinary_rate"
              :sorter="(item1, item2) => item1.ordinary_rate - item2.ordinary_rate" />
            <a-table-column key="poor_cnt" title="差生数" data-index="poor_cnt"
              :sorter="(item1, item2) => item1.poor_cnt - item2.poor_cnt" />
            <a-table-column key="poor_rate" title="差生率" data-index="poor_rate"
              :sorter="(item1, item2) => item1.poor_rate - item2.poor_rate" />
            <a-table-column key="class_score" title="综合" data-index="class_score"
              :sorter="(item1, item2) => item1.class_score - item2.class_score" />
            <a-table-column key="class_average" title="平均分" data-index="class_average"
              :sorter="(item1, item2) => item1.class_average - item2.class_average" />
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="班型分析" key="classtype">
          <a-form layout="inline">
            <a-form-item>
              <a-select v-model="org_id" placeholder="机构" style="width: 100px;" :loading="loading" :disabled="true">
                <a-select-option v-for="(item) in orgList" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-select v-model="campus_id" placeholder="校区" style="width: 140px;" width="200px;" :loading="loading">
                <a-select-option v-for="(item) in campusList" :key="item.id" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" :loading="loading" icon="search" @click="getClassTypeInfoList">搜索</a-button>
              <a-button class="active_btn" :loading="loading" type="primary" icon="file-excel"
                @click="is_export = true; getClassTypeInfoList()">导出</a-button>
            </a-form-item>
          </a-form>
          <a-table :dataSource="classTypeList" :rowKey="item => item.id" :pagination="false" :loading="loading" bordered>
            <a-table-column key="campus_name" title="年级班型">
              <template slot-scope="item">
                {{ item.campus_name }} - {{ item.grade_name }} - {{ classType(item.class_type) }}
              </template>
            </a-table-column>
            <a-table-column key="class_arrive" title="应到" data-index="class_arrive"
              :sorter="(item1, item2) => item1.class_arrive - item2.class_arrive" />
            <a-table-column key="class_actual" title="实到" data-index="class_actual"
              :sorter="(item1, item2) => item1.class_actual - item2.class_actual" />
            <a-table-column key="superior_cnt" title="优生数" data-index="superior_cnt"
              :sorter="(item1, item2) => item1.superior_cnt - item2.superior_cnt" />
            <a-table-column key="superior_rate" title="优生率" data-index="superior_rate"
              :sorter="(item1, item2) => item1.superior_rate - item2.superior_rate" />
            <a-table-column key="ordinary_cnt" title="合格数" data-index="ordinary_cnt"
              :sorter="(item1, item2) => item1.ordinary_cnt - item2.ordinary_cnt" />
            <a-table-column key="ordinary_rate" title="合格率" data-index="ordinary_rate"
              :sorter="(item1, item2) => item1.ordinary_rate - item2.ordinary_rate" />
            <a-table-column key="poor_cnt" title="差生数" data-index="poor_cnt"
              :sorter="(item1, item2) => item1.poor_cnt - item2.poor_cnt" />
            <a-table-column key="poor_rate" title="差生率" data-index="poor_rate"
              :sorter="(item1, item2) => item1.poor_rate - item2.poor_rate" />
            <a-table-column key="classtype_score" title="平均分" data-index="classtype_score"
              :sorter="(item1, item2) => item1.classtype_score - item2.classtype_score" />
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="年级分析" key="grade">
          <a-form layout="inline">
            <a-form-item>
              <a-button class="active_btn" :loading="loading" type="primary" icon="file-excel"
                @click="is_export = true; getGradeInfoList()">导出</a-button>
            </a-form-item>
          </a-form>
          <a-table :dataSource="gradeDataList" :rowKey="item => item.id" :pagination="false" :loading="loading" bordered>
            <a-table-column key="campus_name" title="年级">
              <template slot-scope="item">
                {{ item.grade_name }}
              </template>
            </a-table-column>
            <a-table-column key="grade_arrive" title="应到" data-index="grade_arrive"
              :sorter="(item1, item2) => item1.grade_arrive - item2.grade_arrive" />
            <a-table-column key="grade_actual" title="实到" data-index="grade_actual"
              :sorter="(item1, item2) => item1.grade_actual - item2.grade_actual" />
            <a-table-column key="superior_cnt" title="优生数" data-index="superior_cnt"
              :sorter="(item1, item2) => item1.superior_cnt - item2.superior_cnt" />
            <a-table-column key="superior_rate" title="优生率" data-index="superior_rate"
              :sorter="(item1, item2) => item1.superior_rate - item2.superior_rate" />
            <a-table-column key="ordinary_cnt" title="合格数" data-index="ordinary_cnt"
              :sorter="(item1, item2) => item1.ordinary_cnt - item2.ordinary_cnt" />
            <a-table-column key="ordinary_rate" title="合格率" data-index="ordinary_rate"
              :sorter="(item1, item2) => item1.ordinary_rate - item2.ordinary_rate" />
            <a-table-column key="poor_cnt" title="差生数" data-index="poor_cnt"
              :sorter="(item1, item2) => item1.poor_cnt - item2.poor_cnt" />
            <a-table-column key="poor_rate" title="差生率" data-index="poor_rate"
              :sorter="(item1, item2) => item1.poor_rate - item2.poor_rate" />
            <a-table-column key="grade_average" title="平均分" data-index="grade_average"
              :sorter="(item1, item2) => item1.grade_average - item2.grade_average" />
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="设置分数线" key="student_level">
          <a-table :dataSource="studentLevelList" :rowKey="item => item.id" :pagination="false" :loading="loading"
            bordered>
            <a-table-column key="grade_id" title="年级">
              <template slot-scope="item">
                {{ getGradeName(item.grade_id) }}
              </template>
            </a-table-column>
            <a-table-column key="jion_time" title="分数线">
              <template slot-scope="item">
                <a-form layout="inline">
                  <a-form-item label="优生：">
                    <a-input v-model="item.superior_score" style="width: 70px;"></a-input>
                  </a-form-item>
                  <a-form-item label="合格：">
                    <a-input v-model="item.ordinary_score" style="width: 70px;"></a-input>
                  </a-form-item>
                  <a-form-item label="差生：">
                    <a-input v-model="item.poor_score" style="width: 70px;"></a-input>
                  </a-form-item>
                  <a-button :loading="loading" @click="submitStudentLevel(item)" type="primary">提交</a-button>
                </a-form>
              </template>
            </a-table-column>
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="操作" key="opt">
          <a-button type="primary" @click="sortStudent" style="margin-right: 12px;">学生排名</a-button>
          <a-button :loading="loading" :disabled="makeBtnDisible" @click="makeAllInfo" type="primary">生成数据</a-button>
        </a-tab-pane>
      </a-tabs>
      <div style="text-align: right;margin-top: 1rem;">
        <a-button type="primary" :loading="loading" @click="visible = false">关闭</a-button>
      </div>
    </a-modal>
  </or-layout>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      loading: false,
      student_name: '',
      datalist: [],
      visible: false,
      gradeList: [{ id: 2, name: '二年级' }, { id: 3, name: '三年级' }, { id: 4, name: '四年级' }, { id: 5, name: '五年级' }, {
        id: 6,
        name: '六年级'
      }],
      squadType: [{ name: '培优',id:"0" }, { name: '英才',id:"1" }, { name: '提高',id:"2" },{ name: '冲刺',id:"5" }],
      curr_exam_id: undefined,
      grade_id: 3,
      class_type: "0",
      class_seq: 1,
      orgList: [],
      campusList: [],
      myGradeList: [],
      classTypeList: [],
      studentLevelList: [],
      is_export: false,
      org_id: undefined,
      campus_id: "",
      classList:[],
      studentList: [],
      classDataList: [],
      gradeDataList: [],
      makeBtnDisible: false
    };
  },
  mounted() {
    this.getExamInfoList();
  },
  methods: {
    classType(id){
      return this.squadType.filter(item=>item.id==id)[0].name
    },
    getGradeName(id) {
      return this.myGradeList.filter(item => item.id == id)[0].name
    },
    sortStudent(){
      this.$axios.post('/api/StudentExam/make_student_rank',{
		  data:{
        exam_id: this.curr_exam_id,
		}
      }).then(res=>{
        this.$success({
          title:"完成",
          content:"对学生排名已经操作成功"
        })
      })
    },
    get_exam_squad_list() {
      this.$axios
        .post("/api/StudentExam/get_exam_squad_list", {
          data: {
            campus_id: this.campus_id,
            grade_id: this.grade_id,
            exam_id: this.curr_exam_id,
            class_type: this.class_type
          }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.classList = res.data;
            if(res.data.length>0){
              this.class_seq = res.data[0].squad_id;
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    submitStudentLevel(item) {
      this.loading = true;
      this.$axios
        .post("/api/StudentExam/set_student_level", {
          data: item
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            item = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    makeAllInfo() {
      this.loading = true;
      this.$axios
        .post("/api/StudentExam/make_statistics_info", {
          data: { exam_id: this.curr_exam_id }
        })
        .then(res => {
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.$success({
              title: "完成",
              content: "数据已经生成，请切换标签页查看.",
              okText: "确定"
            });
            this.makeBtnDisible = true;
            this.loading = false;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    switchTabs(tabs) {
      if (tabs == 'squad') {
        //按照班级
        this.getClassInfoList();
      } else if (tabs == 'grade') {
        //按照年级
        this.getGradeInfoList();
      } else if (tabs == 'classtype') {
        //按照班型
        this.getClassTypeInfoList();
      } else if (tabs == 'student_level') {
        //获取分数线
        this.getExamStudentLevel();
      }
    },
    getMyOrgList() {
      this.loading = true;
      this.$axios
        .post("/api/Admin/get_my_org_list")
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.orgList = res.data;
            if (this.orgList.length > 0) {
              this.org_id = this.orgList[0]['id'];
              this.getMyCampusList();
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getTableList() {
      this.loading = true;
      this.$axios
        .post("/api/StudentExam/get_student_list", {
          data: {
            campus_id: this.campus_id,
            grade_id: this.grade_id,
            exam_id: this.curr_exam_id,
            class_type: this.class_type,
            squad_id: this.class_seq,
            student_name:this.student_name,
            is_export: this.is_export
          }
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            if (this.is_export) {
              this.is_export = false;
              window.open(res.data);
            } else {
              this.studentList = res.data;
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getClassInfoList() {
      this.loading = true;
      this.$axios
        .post("/api/StudentExam/get_class_statistics", {
          data: {
            exam_id: this.curr_exam_id,
            campus_id: this.campus_id,
            grade_id: this.grade_id,
            class_type: this.class_type,
            is_export: this.is_export
          }
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            if (this.is_export) {
              this.is_export = false;
              window.open(res.data);
            } else {
              this.classDataList = res.data;
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getGradeInfoList() {
      this.loading = true;
      this.$axios
        .post("/api/StudentExam/get_grade_statistics", {
          data: {
            exam_id: this.curr_exam_id,
            is_export: this.is_export
          }
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            if (this.is_export) {
              this.is_export = false;
              window.open(res.data);
            } else {
              this.gradeDataList = res.data;
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getClassTypeInfoList() {
      this.loading = true;
      this.$axios
        .post("/api/StudentExam/get_classtype_statistics", {
          data: {
            exam_id: this.curr_exam_id,
            campus_id: this.campus_id,
            is_export: this.is_export
          }
        })
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定",
            });
          } else {
            if (this.is_export) {
              this.is_export = false;
              window.open(res.data);
            } else {
              this.classTypeList = res.data;
            }
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getMyCampusList() {
      this.loading = true;
      this.$axios
        .post("/api/Admin/get_my_campus_list", {
          data: { org_id: this.org_id }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.campusList = res.data;
            if (this.campusList.length > 0) {
              this.campus_id = this.campusList[0]['id'];

            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    showExamInfo(id) {
      this.curr_exam_id = id;
      this.visible = true;
      this.getMyOrgList();
      this.getGrade();
      this.get_exam_squad_list()
    },
    getGrade() {
      this.$axios.post("/api/BasicGrade/index", {
        pageinfo: {
          pageSize: 100
        }
      }).then((res) => {
        if (res.code != 200) {
          this.$error({
            title: "错误",
            content: res.msg,
            okText: "确定",
          });
        } else {
          this.myGradeList = res.data.data;
          this.grade_id = res.data.data[0].id;
        }
      })
        .catch((err) => {
          console.error(err);
        });
    },
    getExamInfoList() {
      this.loading = true;
      this.$axios
        .post("/api/StudentExam/get_exam_info_list")
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.datalist = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getExamStudentLevel() {
      this.loading = true;
      this.$axios
        .post("/api/StudentExam/get_student_level_list", {
          data: {
            exam_id: this.curr_exam_id
          }
        })
        .then(res => {
          this.loading = false;
          if (res.code != 200) {
            this.$error({
              title: "错误",
              content: res.msg,
              okText: "确定"
            });
          } else {
            this.studentLevelList = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  }
}
  ;
</script>
<style>
.active_btn {
  margin-left: 5px;
}
</style>